import { render, staticRenderFns } from "./SoftwareGeneralInfoForm.vue?vue&type=template&id=8af0eff6&"
import script from "./SoftwareGeneralInfoForm.vue?vue&type=script&lang=ts&"
export * from "./SoftwareGeneralInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareGeneralInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports